<template>
  <div v-if="tabelaVisivel">
    <div class="text-center" v-if="loadingTabela">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <b-table
        responsive="sm"
        :items="itemsTabela"
        :fields="fieldsTabela"
        per-page="10"
        bordered
        striped
      >
        <template #cell(interacao)="data">
          <div class="d-flex justify-content-end">
            <b-button
              size="sm"
              variant="primary"
              class="me-1"
              data-tooltip="Editar"
              data-tooltip-location="left"
              @click="editarContato(data.item)"
              :disabled="loadingAcoes"
            >
              <i class="mdi mdi-pencil"></i>
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              data-tooltip="Excluir"
              data-tooltip-location="left"
              @click="excluirContato(data.item)"
              :disabled="loadingAcoes"
            >
              <i class="mdi mdi-trash-can"></i>
              <b-spinner
                variant="primary"
                small
                class="ms-2"
                v-if="loadingAcoes"
              ></b-spinner>
            </b-button>
          </div>
        </template>
        <template v-if="!loadingTabela && itemsTabela.length === 0">
          <div>Nenhum contato para este cliente rural cadastrado.</div>
        </template>
      </b-table>

      <div class="row align-items-center">
        <div
          class="col-md-10 text-center"
          v-if="!loadingTabela && !itemsTabela.length"
        >
          <span class="fs-6 text-secondary"
            >Nenhum contato cadastrado para este cliente rural.</span
          >
        </div>
        <div
          :class="[
            itemsTabela.length > 0
              ? 'col-12 d-flex justify-content-end'
              : 'col-md-2 d-flex justify-content-end'
          ]"
        >
          <b-button variant="info" @click="incluirContato">
            <i class="fa fa-solid fa-plus me-2"></i>
            <span>Incluir</span>
          </b-button>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div class="row">
      <div :class="selectTipoContato.value == 6 ? 'col-md-3' : 'col-md-6'">
        <b-form-group
          class="mb-3"
          label="Tipo de Contato"
          :state="state('selectTipoContato')"
          invalid-feedback="Campo obrigatório"
        >
          <multiselect
            label="label"
            track-by="value"
            :max-height="230"
            :allow-empty="true"
            @input="updateStPrincipal"
            v-model="selectTipoContato"
            selected-label="Selecionado"
            :options="tipoContatoOptions"
            placeholder="Selecione o tipo de contato"
            deselect-label="Pressione Enter para remover"
            select-label="Pressione Enter para selecionar"
          >
            <span slot="noResult">Nenhum tipo de contato encontrado</span>
            <span slot="noOptions">Nenhum tipo de contato disponível</span>
          </multiselect>
        </b-form-group>
      </div>
      <div :class="selectTipoContato.value == 6 ? 'col-md-3' : 'col-md-6'">
        <b-form-group
          class="mb-3"
          label="Telefone"
          invalid-feedback="Campo obrigatório"
        >
          <b-form-input
            v-model="telefone"
            type="text"
            trim
            autocomplete="off"
            placeholder="Digite o telefone"
            v-mask="
              telefone.length <= 14 ? '(##) ####-####' : '(##) #####-####'
            "
            :state="state('telefone')"
          />
        </b-form-group>
      </div>
      <div class="row col-md-6" v-if="selectTipoContato.value == 6">
        <div class="col-md-6">
          <b-form-group
            class="mb-3"
            label="O que o contato é seu?"
            :state="state('selectGrauContato')"
            invalid-feedback="Campo obrigatório"
          >
            <multiselect
              label="label"
              track-by="value"
              :max-height="230"
              :show-labels="false"
              v-model="selectGrauContato"
              :options="optionGrauContato"
              placeholder="Selecione um contato de recado"
              deselect-label="Pressione Enter para remover"
              select-label="Pressione Enter para selecionar"
            />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Nome Contato Recado">
            <b-form-input
              v-model="nomeContato"
              type="text"
              trim
              autocomplete="off"
              maxlength="60"
              :state="state('nomeContato')"
              invalid-feedback="Campo obrigatório"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="m-auto">
        <b-form-checkbox
          plain
          value="S"
          unchecked-value="N"
          v-model="contatoPrincipal"
          :disabled="disabledPrincipal || selectTipoContato.value == 6"
        >
          Contato Principal
        </b-form-checkbox>
      </div>
    </div>
    <div class="row mt-3">
      <div
        class="col-md-12 d-flex justify-content-between align-items-end"
        :style="{ height: '70px' }"
      >
        <b-button
          @click="voltar"
          variant="secondary"
          data-tooltip="Voltar"
          data-tooltip-location="bottom"
        >
          <i class="mdi mdi-arrow-left-circle font-size-15"></i>
        </b-button>

        <b-button
          @click="salvarContato"
          variant="success"
          data-tooltip="Salvar"
          data-tooltip-location="bottom"
          :disabled="!habilitaBotaoSalvar || loadingSalvar"
        >
          <i class="mdi mdi-content-save"></i>
          <b-spinner
            class="ms-2"
            small
            variant="primary"
            v-if="loadingSalvar"
          ></b-spinner>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { required, minLength } from "vuelidate/lib/validators";
import { isCheckboxDisabled } from "@/utils/astec/validaContatoPrincipal";
const capitalizeString = str => {
  return str
    .split(" ")
    .map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      tabelaVisivel: true,
      loadingTabela: true,
      loadingSalvar: false,
      submit: false,
      tipoContatoOptions: [],
      itemsTabela: [],
      fieldsTabela: [
        {
          key: "NRTELEFONE",
          label: "Telefone",
          formatter: (value, row, column) => {
            if (!value) return "";
            const formattedNumber = value.replace(/\D/g, "");
            const part1 = formattedNumber.slice(0, -4);
            const part2 = formattedNumber.slice(-4);
            return `(${column.DDD}) ${part1}-${part2}`;
          }
        },
        {
          key: "TPTELEFONE",
          label: "Tipo",
          formatter: value => {
            return this.tipoContatoOptions.find(el => el.value === value).label;
          }
        },
        {
          key: "STPRINCIPAL",
          label: "Principal",
          formatter: value => {
            return value === "S" ? "Sim" : "Não";
          }
        },
        {
          key: "interacao",
          class: "alinharCelulaDireita",
          label: "Ações"
        }
      ],
      selectTipoContato: "",
      telefone: "",
      optionGrauContato: [],
      nomeContato: "",
      selectGrauContato: "",
      contatoPrincipal: null,
      sqTelefone: null,
      sqCliente: null,
      loadingAcoes: false,
      disabledPrincipal: false,
      cdCooperado: null
    };
  },

  computed: {
    habilitaBotaoSalvar() {
      const tipoContato = this.selectTipoContato.value;

      if (Number(tipoContato) !== 6) {
        if (!this.selectTipoContato?.value) return false;
        if (!this.telefone) return false;

        const digitosTelefone = this.telefone.replace(/\D/g, "");
        const isTelefoneValido =
          digitosTelefone.length === 10 || digitosTelefone.length === 11;
        if (!isTelefoneValido) return false;
      }

      if (Number(tipoContato) === 6) {
        const isGrauContatoValido = this.selectGrauContato?.value;
        const isNomeContatoValido = this.nomeContato?.trim().length > 0;
        return isGrauContatoValido && isNomeContatoValido;
      }
      return true;
    }
  },

  created() {
    this.verificarClienteRuralAstec();
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    async verificarClienteRuralAstec() {
      if (this.$store.state.clienteRuralAstec) {
        this.cdCooperado =
          this.$store.state.filtroClienteRuralAstec.cdCooperado ?? null;
        this.sqCliente = this.$store.state.clienteRuralAstec.ID ?? null;
        if (!this.sqCliente) {
          this.sqCliente =
            this.$store.state.clienteRuralAstec.dados.sq_cliente ?? null;
        }
        this.buscarTabelaContatos();
      }
    },

    async buscarTabelaContatos() {
      this.loadingTabela = true;
      try {
        const [
          clienteRuralTelResponse,
          lkpCdTipoResponse,
          lkpContatoRecadoResponse
        ] = await Promise.all([
          this.$http.get(
            "api/astec/getClienteRuralTel/" +
              this.sqCliente +
              "/" +
              this.cdCooperado
          ),
          this.$http.get("api/cadastroCandidato/buscarTipoContato"),
          this.$http.get("api/cadastroCandidato/buscarLkpContatoRecado")
        ]);
        this.itemsTabela = clienteRuralTelResponse.data;
        console.log(this.itemsTabela, "this.itemsTabela");
        console.log(this.sqCliente, "this.sqCliente");
        console.log(this.cdCooperado, "this.sqCliente");
        this.tipoContatoOptions = lkpCdTipoResponse.data.map(item => ({
          label: capitalizeString(item.nm_tipo),
          value: item.cd_tipo
        }));
        this.optionGrauContato = lkpContatoRecadoResponse.data.map(item => ({
          ...item,
          label: capitalizeString(item.nm_contato),
          value: item.sq_contato_recado
        }));
        this.$emit("visibilidade-botao", true);
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loadingTabela = false;
      }
    },

    incluirContato() {
      this.tabelaVisivel = false;
      this.$emit("visibilidade-botao", false);
      this.telefone = "";
      this.selectTipoContato = [];
      if (!this.itemsTabela.length) {
        this.contatoPrincipal = "S";
        this.disabledPrincipal = true;
      } else {
        this.contatoPrincipal = "N";
        this.disabledPrincipal = false;
      }
      this.sqTelefone = "";
      this.selectGrauContato = [];
      this.nomeContato = "";
    },

    editarContato(item) {
      this.tabelaVisivel = false;
      this.$emit("visibilidade-botao", false);
      this.telefone = item.DDD + item.NRTELEFONE;
      this.selectTipoContato = this.tipoContatoOptions.find(
        el => el.value === item.TPTELEFONE
      );
      this.contatoPrincipal = item.STPRINCIPAL === "S" ? "S" : "N";
      this.sqTelefone = item.SQTELEFONE;
      if (item.TPTELEFONE == 6) {
        this.selectGrauContato = this.optionGrauContato.find(
          el => el.value === item.SQCONTATORECADO
        );
        this.nomeContato = item.NMCONTATORECADO;
      }
      this.disabledPrincipal = isCheckboxDisabled(this.contatoPrincipal);
      this.desabilitaContatoPrincipal(this.contatoPrincipal);
    },

    excluirContato(item) {
      Swal.fire({
        title: "Tem certeza?",
        text:
          "Você realmente deseja excluir este contato de cliente rural? Essa ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.isConfirmed) {
          this.loadingAcoes = true;
          var obj = {
            sqCliente: this.sqCliente,
            sqTelefone: item.SQTELEFONE
          };
          this.$http
            .post("/api/astec/deletarContatoClientesRurais", obj)
            .then(() => {
              Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Contato de cliente rural excluído com sucesso!"
              });
              this.verificarClienteRuralAstec();
            })
            .catch(err => {
              this.$tools.alerta(err.response.data, "error");
            })
            .finally(() => {
              this.loadingAcoes = false;
            });
        }
      });
    },

    voltar() {
      this.sqTelefone = null;
      this.tabelaVisivel = true;
      this.$emit("visibilidade-botao", true);
    },

    updateStPrincipal() {
      if (this.selectTipoContato.value == 6) {
        this.contatoPrincipal = "N";
      }
    },

    async salvarContato() {
      this.loadingSalvar = true;
      this.submit = true;

      if (this.selectTipoContato.value != 6) {
        this.selectGrauContato = "temp";
        this.nomeContato = "temp";
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loadingSalvar = false;
        return;
      }

      const telefoneNumerico = this.telefone.replace(/\D/g, "");

      if (/^(\d)\1+$/.test(telefoneNumerico.substring(2))) {
        this.$tools.alerta(
          "Número de telefone inválido. Não é permitido cadastrar números com todos os dígitos repetidos.",
          "error"
        );
        this.loadingSalvar = false;
        return;
      }

      const obj = {
        sqCliente: this.sqCliente,
        ddd: this.telefone.substring(1, 3),
        nrTelefone: this.telefone.substring(5).replace("-", ""),
        cdTipo: this.selectTipoContato.value,
        stPrincipal: this.contatoPrincipal === "S" ? "S" : "N",
        sqTelefone: this.sqTelefone ?? null,
        sqContatoRecado:
          this.selectTipoContato.value == 6
            ? this.selectGrauContato.value
            : null,
        nmContatoRecado:
          this.selectTipoContato.value == 6 ? this.nomeContato : ""
      };
      console.log(obj, "obj contato");
      try {
        console.log("Enviando", obj);
        await this.$http.post("api/astec/insertContatosAstec", obj);
        this.$tools.alerta("Cadastrado com sucesso", "success");
        this.tabelaVisivel = true;
        if (obj.stPrincipal == "S") {
          this.$emit(
            "insertTelefoneClienteRural",
            "(" + obj.ddd + ") " + obj.nrTelefone
          );
        }
        this.verificarClienteRuralAstec();
        this.$emit("enableTab", "email");
      } catch (err) {
        this.$tools.alerta(err.response.data, "error");
      } finally {
        this.loadingSalvar = false;
      }
    },

    /**
     * Desabilita o checkbox de contato principal se o valor for "S"
     * @param {string} valueContatoPrincipal - Valor do contato principal
     * @returns {boolean} - Retorna true se desabilitado, false caso contrário
     */
    desabilitaContatoPrincipal(valueContatoPrincipal) {
      this.disabledPrincipal = valueContatoPrincipal === "S" ? true : false;
      return this.disabledPrincipal;
    }
  },

  validations: {
    selectTipoContato: { required },
    telefone: { required, minLength: minLength(14) },
    selectGrauContato: { required },
    nomeContato: { required }
  }
};
</script>
